import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";

export default function MailboxDisclosureGate() {
  const { user, refresh } = useAuth();
  const [busy, setBusy] = useState(false);

  if (!user || !user.mailbox_disclosure_required) return null;

  const accept = async () => {
    setBusy(true);
    try {
      await api.post("/auth/mailbox-disclosure/accept", { accepted: true });
      await refresh();
      toast.success("Acknowledged");
    } catch (e) {
      toast.error(e.response?.data?.detail || "Could not record acknowledgement");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="mailbox-disclosure-gate"
      className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/80 backdrop-blur-sm p-4">
      <div className="max-w-lg w-full border border-white/15 bg-[#0a1430] p-7 shadow-2xl">
        <h2 className="text-white text-xl font-semibold tracking-tight mb-3">
          Mailbox Access Disclosure
        </h2>
        <p className="text-white/70 text-sm leading-relaxed mb-3">
          As a D.O.X Capital partner you are assigned a <strong className="text-white">@thedoxs.com</strong> business
          inbox. D.O.X Capital may access, monitor, send, and receive email through this mailbox for compliance,
          supervision, and transaction-coordination purposes. This inbox is a firm resource and is not private
          personal correspondence.
        </p>
        <p className="text-white/50 text-xs leading-relaxed mb-5">
          Please review the full{" "}
          <Link to="/legal/mailbox-access" target="_blank" rel="noreferrer"
            data-testid="gate-mailbox-link" className="text-white underline underline-offset-4">
            Mailbox Access Disclosure
          </Link>. Your acknowledgement is recorded with a timestamp and your IP address.
        </p>
        <Button data-testid="mailbox-disclosure-accept" disabled={busy} onClick={accept}
          className="w-full rounded-none bg-white text-black hover:bg-white/90 h-11">
          {busy ? "Recording…" : "I Acknowledge and Continue"}
        </Button>
      </div>
    </div>
  );
}
